<p class="value dpe dpe_{{ energy_rate }}">
    <b>{{ energy_rate }}</b>
    <span class="text-black" *ngIf="energy_rate == ''">-</span>
    <span *ngIf="energy_rate_value">({{ energy_rate_value }})</span>
</p>
<i class="fa fa-info-circle" *ngIf="show_popup && (energy_rate_value || energy_rate)" (click)="popup()"></i>
